const fileDrag = function (Vue) {
  Vue.directive('file-drag', function (el, binding) {
    let oDiv = el; //当前元素
    let self = this; //上下文

    //禁止选择网页上的文字 
    oDiv.children[0].onselectstart = function () {
      return false;
    };
    oDiv.children[0].onmousedown = function (e) {
      if (binding.value) return false;
      //鼠标按下，计算当前元素距离可视区的距离
      let disX = e.clientX - oDiv.offsetLeft;
      let disY = e.clientY - oDiv.offsetTop;
      document.onmousemove = function (e) {
        //通过事件委托，计算移动的距离
        let l = e.clientX - disX;
        let t = e.clientY - disY;
        //屏幕高度
        let h = document.body.clientHeight ||
          window.innerHeight ||
          document.documentElement.clientHeight;
        //屏幕宽度
        let w = document.body.clientWidth ||
          window.innerWidth ||
          document.documentElement.clientWidth;
        //左边菜单伸缩状态的宽度 图简单直接写了数字 严谨的小伙伴可以直接获取侧菜单的宽度
        let leftBar = 64;
        //判断有没有超过边界点
        if (l > (w - oDiv.offsetWidth)) l = w - oDiv.offsetWidth;
        if (l < leftBar) l = leftBar;
        if (t > (h - oDiv.offsetHeight)) t = h - oDiv.offsetHeight;
        if (t < 52) t = 52;
        //移动当前元素
        oDiv.style.left = l + "px";
        oDiv.style.top = t + "px";
      };
      document.onmouseup = function (e) {
        document.onmousemove = null;
        document.onmouseup = null;
      };
      //return false不加的话可能导致黏连，就是拖到一个地方时div粘在鼠标上不下来，相当于onmouseup失效
      return false;
    };
  })
}

export default fileDrag